import getAFOneLinkConfig from './getAFOneLinkConfig';

export default getAFOneLinkConfig;
